import React, { useEffect } from 'react'
import DataTable from '../datatable'
import { useState } from 'react'
import { PAGINATION_DEFAULT, queryStatusConfig } from '../../utils/constants'
import AddQuery from '../modal/hr-section/queries/add-query'
import {
  useChangeQueryStatus,
  useDeleteQuery,
  useGetQueries,
} from '../../redux/human-resources/hook/queries'
import { useHistory } from 'react-router-dom'
import Button from '../button'
import TrackQuery from '../modal/hr-section/queries/TracKQuery'
import AddBulkQuery from '../modal/hr-section/queries/AddBulkQuery'

const QueriesTab = () => {
  useEffect(() => {}, [])

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { refetch: refetchQueries, data: queriesData } = useGetQueries(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const [showAddQuery, setShowAddQuery] = useState(false)
  const [queryData, setQueryData] = useState()
  const [trackQuery, setTrackQuery] = useState(false)
  const [bulkQuery, setBulkQuery] = useState(false)

  const tableConfig = {
    headers: ['Employee Name', 'Date Added', 'Email', 'Subject', 'Status'],
    keys: ['employeeName', 'date_created', 'email', 'subject', 'status'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Email',
        key: 'email',
      },
    },
  }
  const { mutateAsync: deleteQuery } = useDeleteQuery()
  const { mutateAsync: resolve, isLoading: resolveLoading } =
    useChangeQueryStatus()

  const actionConfig = [
    {
      name: 'View Query',
      color: 'green',
      action: (id) => {
        let index = queriesData.data.findIndex((item) => item.id === id)
        setQueryData(queriesData.data[index])
        setTrackQuery(true)
      },
    },
    {
      name: 'Resolve Query',
      color: 'green',
      action: (id) => {
        const handleResolve = async () => {
          let index = queriesData?.data?.findIndex((item) => item.id === id)
          let queryItem = queriesData.data[index]
          let payload = {
            id: queryItem.id,
            data: { status: queryItem.status === 1 ? 0 : 1 },
          }

          await resolve(payload).then(() => {
            refetchQueries()
          })
        }
        handleResolve()
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: (id) => {
        let index = queriesData.data.findIndex((item) => item.id === id)
        deleteQuery(queriesData.data[index].id)
      },
    },
  ]

  return (
    <div className='flex flex-col bg-white rounded mt-4 border'>
      {showAddQuery ? (
        <AddQuery
          isOpen={showAddQuery}
          setShowAddQuery={setShowAddQuery}
          // queryData={queryData}
          title={'Add Query'}
          buttonText={'Save Query'}
          refetchQueries={refetchQueries}
        />
      ) : null}
      {/* {querySuccess ? (
        <NewQuerySuccess
          isOpen={querySuccess}
          setQuerySuccess={setQuerySuccess}
          employeeData={employeeData}
          setTrackQuery={setTrackQuery}
          trackQuery={trackQuery}
          setNewQuery={setNewQuery}
          setShowSendQuery={setShowSendQuery}
          queryData={queryData}
        />
      ) : null} */}
      {trackQuery ? (
        <TrackQuery
          isOpen={trackQuery}
          setTrackQuery={setTrackQuery}
          query={queryData}
        />
      ) : null}
      {bulkQuery ? (
        <AddBulkQuery isOpen={bulkQuery} setBulkQuery={setBulkQuery} />
      ) : null}
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-2'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Queries
        </div>
        <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full'>
          <div className='md:w-fit w-[100%]'>
            <Button
              text='New Query'
              type='button'
              theme='primary'
              className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
              textClass={'!text-[11px]'}
              leftIcon={'add'}
              onClick={() => {
                setShowAddQuery(true)
                console.log(showAddQuery)
              }}
            />
          </div>
          <div className='md:w-fit w-[100%]'>
            <Button
              text='Bulk Query'
              type='button'
              theme='primary'
              className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
              textClass={'!text-[11px]'}
              leftIcon={'add'}
              onClick={() => {
                setBulkQuery(true)
              }}
            />
          </div>
        </div>
      </div>
      <hr className='divider mt-2 mb-1' />
      <DataTable
        data={queriesData}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        statusConfig={queryStatusConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        searchData={true}
      />
    </div>
  )
}

export default QueriesTab
